import { render, staticRenderFns } from "./whatsAppMessageCard.vue?vue&type=template&id=1eefc4ac"
import script from "./whatsAppMessageCard.vue?vue&type=script&lang=ts"
export * from "./whatsAppMessageCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports